module.exports = __webpack_public_path__ + "static/project-16a-68e8f773d8ce66a75258e7472a2dffbd.png";